// ISCC EU product types for the Validate Declaration form — no endpoint serves them yet.
// TODO: localise the labels if the compliance domain ever needs it.
export const PRODUCT_TYPES = Object.freeze([
  'Biodiesel',
  'Bioethanol',
  'Biogas / Biomethane',
  'Biomethanol',
  'Co-processed oil to be used for replacement of diesel',
  'Co-processed oil to be used for replacement of marine fuel',
  'Co-processed oil to be used for replacement of naphtha',
  'Co-processed oil to be used for replacement of petrol',
  'Co-processed oil to be used for replacement of jet fuel',
  'Co-processed oil to be used for replacement of liquefied petroleum gas',
  'Co-processed oil to be used for replacement of diesel / petrol / jet fuel produced from biomethane',
  'Hydrotreated Vegetable Oil (HVO)',
  'Pure vegetable oil',
  'Used Cooking Oil',
  'Other',
]);

export const buildProductTypeOptions = () =>
  PRODUCT_TYPES.map((name) => ({ value: name, label: name }));
